export const light = {
	body: "white",
	text: "black",
	highlight: "orange",
	dark: "black",
	secondaryText: "gray",
	imageHighlight: "gray",
	compImgHighlight: "gray",
	jacketColor: "gray",
	headerColor: "gray",
};

export const dark = {
	body: "black",
	text: "white",
	cardtext: 'black',
	highlight: "orange",
	dark: "#3792cb",
	secondaryText: "white",
	imageHighlight: "lightgray",
	compImgHighlight: "navy",
	jacketColor: "navy",
	headerColor: "lightgray",
};

